module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "customer-wrap"
  }, [_c('email-mobile-form', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.userStore.token && !_vm.forceShow),
      expression: "!userStore.token && !forceShow"
    }],
    on: {
      "loginUser": _vm.loginUser,
      "nonUser": _vm.nonUser,
      "getUserInfo": _vm.getUserInfo,
      "hideVeriForm": _vm.hideVeriForm
    }
  }), _vm._v(" "), _c('customer', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.userStore.token || _vm.forceShow),
      expression: "userStore.token || forceShow"
    }],
    ref: "customer",
    attrs: {
      "user": _vm.user,
      "flash": _vm.flash,
      "backLink": _vm.backLink,
      "showLoginBox": _vm.showLoginBox
    }
  })], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4d1de332", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4d1de332","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Customer/index.vue
// module id = 2088
// module chunks = 0